import moment from "moment-timezone";

export class DateTimeHelper {
    static formatTimespan(minutes: number): string {
      if (minutes) {
        var hours = Math.floor(minutes / 60);     
        var minutes = minutes % 60;
        return hours + "h " + Math.round(minutes) + "m";
      }

      return "";
    }

    static formatDateToTime(date: moment.Moment): string {
      if (date) {
        return moment.utc(date).tz('Europe/London').local().format("HH:mm");
      }

      return "";
    }

    static formatDateAndTime(date: moment.Moment): string {
      if (date) {
        return moment.utc(date).tz('Europe/London').local().format("DD/MM/YY HH:mm");
      }

      return "";
    }

    static formatDate(date: moment.Moment): string {
      if (date) {
        return moment.utc(date).tz('Europe/London').local().format("DD/MM/YY");
      }

      return "";
    }

    static parseDate(str): any {
      var mdy = str.split('/');
      return new Date(mdy[2], mdy[0]-1, mdy[1]);
    }

    static daysSinceToday(date: any) {
      if (date) {
        let today = moment();
        let dateSince = moment(DateTimeHelper.parseDate(date));
        return today.diff(dateSince, 'days');
      }

      return "";
    }

    static daysBetweenDate(first: any, second: any) {
      first = DateTimeHelper.parseDate(first)
      // Take the difference between the dates and divide by milliseconds per day.
      // Round to nearest whole number to deal with DST.
      return Math.round((second-first)/(1000*60*60*24));
    }
}
